import { ImportDetailTabs } from '../models/import-detail-tabs';

export const getImportChangeStateTranslationId = (key: string, selectedTab: ImportDetailTabs) => {
    switch (key.toUpperCase()) {
        case 'NEW':
            return 'app.imports.detail.new';
        case 'CHANGED':
            if (selectedTab === ImportDetailTabs.Imported) {
                return 'app.imports.detail.toChange';
            } else {
                return 'app.imports.detail.changed';
            }
        case 'DELETE':
            if (selectedTab === ImportDetailTabs.Imported) {
                return 'app.imports.detail.toDelete';
            } else {
                return 'app.imports.detail.delete';
            }
        case 'UNCHANGED':
            return 'app.imports.detail.unchanged';
        default:
            return;
    }
};
